export default __webpack_public_path__ + "static/hq8-c7572c4b30c74a66931cac84e3028767.jpg";